import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, IconButton, Icon, Message, Row, Container } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import BackgroundForm from './BackgroundForm'
import { useForm, Controller } from 'react-hook-form'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import { updateForm0, saveForm0 } from '../../../redux/actions/background'
import ButtonPanel from '../../ButtonPanel'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function BackgroundWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()

  const [formSchema, setFormSchema] = useState(schema)
  // const [formSchema, setFormSchema] = useState(mockSchema)
  const [editorData, setEditorData] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('formSchema', formSchema)
    var data = formSchema.editorData.value

    formSchema?.mapFileData?.map((item) => {
      // console.log('item :', item)
      // console.log('item.key :', item.key.replace('[[', '').replace(']]', ''))
      if (item.link != null) {
        let link = `<a href="${item.link}" target="_blank"> ${item.key
          .replace('[[', '')
          .replace(']]', '')} </a>`
        data = data.replace(item.key, link)
      }
    })

    // console.log('data : ', data)

    setEditorData(data)
  }, [formSchema])

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        // console.log('call update.')
        response = await updateForm0(projectId, request)
      } else {
        // console.log('call save.')
        response = await saveForm0(projectId, request)
      }
      // console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)
    // console.log('formSchema', formSchema)
    // var editorData = data.editorData

    let request = {
      id: formSchema.id,
      projectVersionId: 'projectId',
      editorData: data.editorData,
      mapFileData: [...data.mapFileData],
    }

    handleCallService(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        <BackgroundForm
          key={'form0'}
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          getValues={getValues}
        />
      ) : editorData ? (
        <>
          <div
            style={{ wordWrap: 'break-word' }}
            dangerouslySetInnerHTML={{ __html: editorData }}
          />
        </>
      ) : (
        '-ไม่ได้ระบุ-'
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || 'ความเป็นมาหลักการและเหตุผล'}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}
